import { useEffect, useState } from "react";

const STORAGE_KEY = "debugMode";
const CHANGE_EVENT = "debugModeChange";

export function loadDebugMode() {
  const param = new URLSearchParams(window.location.search).get("debug");
  if (param !== null) sessionStorage.setItem(STORAGE_KEY, param);
  return (param ?? sessionStorage.getItem(STORAGE_KEY)) === "true";
}

export function saveDebugMode(enabled) {
  sessionStorage.setItem(STORAGE_KEY, String(enabled));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: enabled }));
}

export function useDebugMode() {
  const [enabled, setEnabled] = useState(loadDebugMode);
  useEffect(() => {
    const onChange = (e) => setEnabled(Boolean(e.detail));
    window.addEventListener(CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CHANGE_EVENT, onChange);
  }, []);
  return enabled;
}
